import { Footer } from 'components/Footer'
import { Layout } from 'components/Layout'
import { Stack } from 'components/Stack'
import { Text } from 'components/Text'
import { VerticalSeparator } from 'components/VerticalSeparator'
import { useTranslation } from 'hooks/useTranslation'
import { TranslationKeys } from 'locales/translationKeys'
import React, { ReactNode, useMemo, useState } from 'react'
import { DesktopMenu } from './components/DesktopMenu'
import { MyAccountHeader } from './components/MyAccountHeader/MyAccountHeader'
import {
  Content,
  MyAccountContent,
  MyAccountRoot,
  TitleSection,
  Wrapper,
} from './UserLayout.styles'
import { Client } from '../../../../models/Client'
import { PromotionalCreditsBanner } from './components/AccountBanner/PromotionalCreditsBanner'
import { useMyAccountMenu } from './hooks/useMyAccountMenu'

type UserLayoutProps = {
  title: TranslationKeys
  description: TranslationKeys
  children?: ReactNode
  client?: Client
}

export const UserLayout: React.FC<UserLayoutProps> = ({ title, description, children, client }) => {
  //TODO MOVE FETCHCLIENT TO HERE TO REDUCE API CALLS?

  const { menuSections, activeSection } = useMyAccountMenu()
  const { t } = useTranslation()

  const header = useMemo(() => <MyAccountHeader />, [])

  const hasPromotionalCredits =
    client && client?.promotionalCredits && client?.promotionalCredits == 0

  const totalSubscriptions = useMemo(() => {
    const bulk = menuSections.find((section) => section.title.includes('Bulk'))?.items ?? []
    const pets = menuSections.find((section) => section.title.includes('Plan'))?.items ?? []
    return [...bulk, ...pets].length
  }, [menuSections])

  return (
    <Layout header={header} hideCTA>
      <MyAccountRoot>
        <Stack direction="column" gap="14">
          <MyAccountContent>
            <Stack gap={{ '@iniitla': '2', '@bp2': '5' }} direction="column">
              <TitleSection>
                <Stack gap="5" alignItems="center">
                  <Text css={{whiteSpace: 'nowrap'}} as="h1" size="h3" weight="medium">
                    {t(title)}
                  </Text>
                  <VerticalSeparator />
                  <div>
                   <Text as="p">{t(description)}</Text>
                  </div>
                </Stack>
              </TitleSection>
              {client && (
                <PromotionalCreditsBanner
                  promotionalCredits={client.promotionalCredits}
                  totalSubscriptions={totalSubscriptions}
                />
              )}
              <Wrapper css={{ paddingTop: hasPromotionalCredits ? '$4' : '' }}>
                <DesktopMenu menusections={menuSections} activesection={activeSection} />
                <Content>{children}</Content>
              </Wrapper>
            </Stack>
          </MyAccountContent>
          <Footer />
        </Stack>
      </MyAccountRoot>
    </Layout>
  )
}

UserLayout.displayName = 'UserLayout'
